import { api } from "../api";
import { WardRoundTemplate } from "../../model/templates/WardRoundTemplate";
import { parseWardRoundTemplate } from "../../parsers/template/parseWardRoundTemplate";

export const getAllWardRoundTemplates = async (): Promise<WardRoundTemplate[]> => {
  const result = await api.services.wardRoundTemplates.getAllWardRoundTemplates();
  return result.data.map(parseWardRoundTemplate);
};
